import { FC, useState } from 'react';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';

interface ClickOpenDateTimePickerProps {
  label: string;
  value: Date | null;
  onChange: (v: Date | null) => void;
  required?: boolean;
  size?: 'small' | 'medium';
}

/**
 * Desktop DateTimePicker that opens the calendar/time popup on a click anywhere
 * in the field (not just the trailing icon). The field is read-only so a click
 * can't drop into the editable "MM/DD/YYYY hh:mm aa" mask — the calendar/clock
 * popup still sets the value. Keeps the trailing calendar icon and the column
 * (desktop) time picker. Shared by the barn-visit and appointment dialogs.
 */
const ClickOpenDateTimePicker: FC<ClickOpenDateTimePickerProps> = ({
  label,
  value,
  onChange,
  required,
  size,
}) => {
  const [open, setOpen] = useState(false);
  return (
    <DateTimePicker
      label={label}
      value={value}
      onChange={onChange}
      open={open}
      onOpen={() => setOpen(true)}
      onClose={() => setOpen(false)}
      slotProps={{
        // Read-only FIELD → no inline section editing (a click can't drop into
        // the mask); picker-level readOnly would disable the views too.
        field: { readOnly: true },
        textField: {
          fullWidth: true,
          required,
          size,
          onClick: () => setOpen(true),
          sx: { cursor: 'pointer' },
        },
      }}
    />
  );
};

export default ClickOpenDateTimePicker;
